import { ReactNode, useEffect, useMemo } from 'react'
import { initialQueryState, useDebounce } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import {
  ActiveFilter,
  ActiveFiltersBar,
  Input,
  TableFilter,
  TableFilters,
} from '../../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

type Props = {
  /** Conteúdo à direita da linha dos campos (ex.: "Adicionar" ou barra de seleção em lote). */
  actions?: ReactNode
}

export const EmpresasClienteListSearchComponent = ({ actions }: Props) => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const { t } = useT()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(() => {
    const nome = debouncedFilters.nome.trim()
    return nome ? `nome~*${nome}*` : ''
  }, [debouncedFilters])

  useEffect(() => {
    updateState({
      ...initialQueryState,
      search,
    })
  }, [search, updateState])

  // Chip da faixa "Filtros ativos": o × limpa o campo.
  const activeFilters: ActiveFilter[] = filters.nome.trim()
    ? [
        {
          key: 'nome',
          label: t('cols.empregadorAso'),
          value: `“${filters.nome.trim()}”`,
          onRemove: () => setFilter('nome', ''),
        },
      ]
    : []

  return (
    <TableFilters
      actions={actions}
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'empregador encontrado' : 'empregadores encontrados'}`
          }
        />
      }
    >
      <TableFilter label={t('cols.empregadorAso')} wide>
        <Input
          placeholder='Digite o empregador'
          value={filters.nome}
          onChange={(e) => setFilter('nome', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}
